import React, { useEffect, useState } from 'react';
import ProjectCart from './ProjectCart';

const Projects = () => {
    const [projects, setProjects] = useState([])
    const [showAll, setShowAll] = useState(false)
    const [isTransitioning, setIsTransitioning] = useState(false)

    useEffect(() => {
        fetch('https://portfolio-server-silk.vercel.app/projects')
            .then(res => res.json())
            .then(data => setProjects(data))
    }, [])

    const handleToggleProjects = (nextShowAll) => {
        setIsTransitioning(true)

        setTimeout(() => {
            setShowAll(nextShowAll)
            setIsTransitioning(false)

            if (!nextShowAll) {
                const projectsSection = document.getElementById('projects')
                if (projectsSection) {
                    projectsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
            }
        }, 180)
    }

    const visibleProjects = showAll ? projects : projects.slice(0, 6)

    return (
        <div id='projects' className='my-20'>
            <div>
                <h1 className='font-semibold opacity-30 text-yellow-100 text-4xl md:text-5xl text-center mt-2 mb-4'>PROJECTS</h1>
                <p className='text-center text-yellow-100 opacity-80 max-w-3xl mx-auto px-4'>
                    Selected full-stack projects where I led backend architecture,
                    API development, data modeling, and deployment workflows.
                </p>
                <div
                    className={`p-5 mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-300 ease-out ${
                        isTransitioning
                            ? 'opacity-60 scale-[0.99]'
                            : 'opacity-100 scale-100'
                    }`}
                >
                    {
                        visibleProjects.map(project => <ProjectCart key={project.id || project._id} project={project} />)
                    }
                </div>
                {!showAll && projects.length > 6 && (
                    <div className='flex justify-center mt-8'>
                        <button
                            onClick={() => handleToggleProjects(true)}
                            className='btn-brand-secondary'
                        >
                            Load More
                        </button>
                    </div>
                )}
                {showAll && projects.length > 6 && (
                    <div className='flex justify-center mt-4'>
                        <button
                            onClick={() => handleToggleProjects(false)}
                            className='btn-brand-secondary'
                        >
                            Show Less
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Projects;